export default "<p>\n  redirecting to your page!\n</p>\n";